import React from 'react'
import {
  AnnotationIcon,
  LockClosedIcon,
  MapIcon,
  LocationMarkerIcon,
  BriefcaseIcon,
  GlobeIcon
} from '@heroicons/react/outline'

export const features = [
  {
    name: 'Contribute to your safety',
    description: (
      <p className='text-base leading-normal'>
        Review Driver, Alert Overspeeding, Report Bad Driving and Call Emergency Service...
      </p>
    ),
    icon: LockClosedIcon,
    detail: {
      title: 'Contribute to your safety',
      featureTitle: ' Review Driver',
      featureText1: `Passengers have the option of reviewing the driver's service in the course of the
      journey. A driver may be commended with a 4 or 5-star rating, or thumb-downed with a
      one or two-star rating. As well as comments on specific instances. Such ratings help to
      improve the driving service and experience.`,
      featureTitle2: 'Alert over-speeding',
      featureText2: `A bus that exceeds the acceptable speed limit gets a beeping sound from a passenger's
      app. More overspeeding keeps the sound beeping. As long as a passenger leaves it on,
      it sounds an alert to the driver of the passenger’s discomfort and the driver may do the
      needful.`,
      featureTitle3: 'Report bad driving.',
      featureText3:
        'Oya makes it possible for riders to report driver misconduct in real-time.',
      featureTitle4: 'Call emergency service.',
      featureText4:
        'With just a click of a button, you can call tailored emergency services depending on your emergency and text loved ones with your live location.'
    }
  },
  {
    name: 'Join Bus Midroute',
    description: (
      <p className='text-base leading-normal'>
        Avoid Traffic, Reduce Taxi Fare To Station, Reduce Tavel Stress Reach Faster…
      </p>
    ),
    icon: LocationMarkerIcon,
    detail: {
      title: 'Join Bus Midroute',
      featureTitle: 'Avoid Traffic ',
      featureText1:
        `To travel at your convenience, purchase a ticket, and board a bus. You can buy a ticket
        mid-route and arrange to be picked up at your destination.`,
      featureTitle2: 'Reduce Taxi Fare to Station',
      featureText2: `Just purchase a ticket via mid-route, choose your pickup point and conveniently wait for your
      bus to pick you up without going to the station.`,
      featureTitle3: 'Reduce Travel Stress',
      featureText3:
        'Travel with comfort, assurance, and peace of mind knowing that your luggage is secure and can be quickly located.',
      featureTitle4: '',
      featureText4: ''
    }
  },
  {
    name: 'Welfare Package',
    description: (
      <p className='text-base leading-normal'>
        Instant Financial Relief and ICE...
      </p>
    ),
    icon: BriefcaseIcon,
    detail: {
      title: 'Instant Financial Relief and ICE',
      featureTitle: 'Jack, Where are you? ',
      featureText1: 'Share your travels and current location with loved ones.',
      featureTitle2: 'Accessible',
      featureText2: 'Use the smartphone app, web app, or USSD to access our services.',
      featureTitle3: 'Welfare',
      featureText3: 'We offer necessary support and assistance to passengers in the event of unforeseen circumstances.',
      featureTitle4: '',
      featureText4: ''
    }
  },
  {
    name: 'Jack, Where Are You?',
    description: (
      <p className='text-base leading-normal'>
        Allow Family & Friends to Follow your Journey...
      </p>
    ),
    icon: MapIcon,
    detail: {
      title: 'Jack, Where Are You?',
      featureTitle: 'Jack, Where are you?',
      featureText1: 'Share your travels and current location with loved ones.',
      featureTitle2: '',
      featureText2: '',
      featureTitle3: '',
      featureText3: '',
      featureTitle4: '',
      featureText4: ''
    }
  },
  {
    name: 'Accessible',
    description: (
      <p className='text-base leading-normal'>
        Access Our Services on Web, Mobile and through USSD...
      </p>
    ),
    icon: GlobeIcon,
    detail: {
      title: 'Accessible',
      featureTitle: 'Access Our Services on Web, Mobile and through USSD ',
      featureText1: '',
      featureTitle2: '',
      featureText2: '',
      featureTitle3: '',
      featureText3: '',
      featureTitle4: '',
      featureText4: ''
    }
  },
  {
    name: 'Help & Support',
    description: (
      <p className='text-base leading-normal'>
        Receive Help And Support Whenever You Need It Learn Your Route, Learn
        Where YouAre At Any Time...
      </p>
    ),
    icon: AnnotationIcon,
    detail: {
      title: 'Help & Support',
      featureTitle: 'Help & Support',
      featureText1: `Receive help and support whenever you need it to learn your route, learn where you are
      at any time...`,
      featureTitle2: '',
      featureText2: '',
      featureTitle3: '',
      featureText3: '',
      featureTitle4: '',
      featureText4: ''
    }
  }
]
